/* CY TEXT COLUMN WITH IMAGE extras: touch (2026-10-12, owner on the mouse pads Care tiles: "on touch hover effect on mobile").
   The section system's hover (cy-section-system.js) runs on mouse devices only. On touch, a tile of a "Mouse pad tiles" section
   ([data-cy-weave]) lights up when tapped or pressed: the spotlight sits under the finger, the red arc starts there and runs once
   round the border (the Aurora edge), the stitching and number turn red and the tile's icon replays; then it fades out. A scroll
   that starts on a tile cancels it at once. Reduced motion: the arc lights in place without running. Mouse devices: untouched. */
(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)');
  const ensure = (tile, cls) => tile.querySelector(':scope > .' + cls) || tile.appendChild(Object.assign(document.createElement('span'), { className: cls, ariaHidden: 'true' }));
  const arm = root => (root || document).querySelectorAll('[data-cy-weave] .hdt-tcwi-inner:not([data-cy-touch])').forEach(tile => {
    tile.dataset.cyTouch = '1';
    let raf = 0, off = 0;
    const stop = now => { cancelAnimationFrame(raf); clearTimeout(off); if (now) tile.classList.remove('is-touch'); };
    tile.addEventListener('pointerdown', e => {
      if (e.pointerType === 'mouse') return;
      stop(true); ensure(tile, 'cys-spot');   /* 2026-10-16 pm: the light is the frame's .cy-edge__light (cybeart.js), driven through --cy-ang */
      const r = tile.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      const a0 = Math.atan2(y - r.height / 2, x - r.width / 2) * 180 / Math.PI + 90;
      tile.style.setProperty('--mx', x + 'px'); tile.style.setProperty('--my', y + 'px'); tile.style.setProperty('--cy-ang', a0 + 'deg');
      tile.classList.add('is-touch');
      const ic = tile.querySelector('.cyp-fi'); if (ic) { ic.classList.remove('is-play'); void ic.getBoundingClientRect(); ic.classList.add('is-play'); }
      if (!still.matches) {
        const t0 = performance.now(), D = 1100;
        const run = t => { const k = Math.min(1, (t - t0) / D), ease = 1 - Math.pow(1 - k, 3);
          tile.style.setProperty('--cy-ang', (a0 + 360 * ease) + 'deg'); if (k < 1) raf = requestAnimationFrame(run); };
        raf = requestAnimationFrame(run);
      }
    });
    const end = () => { clearTimeout(off); off = setTimeout(() => tile.classList.remove('is-touch'), 1300); };
    tile.addEventListener('pointerup', e => { if (e.pointerType !== 'mouse') end(); });
    tile.addEventListener('pointercancel', () => stop(true));   /* the finger started a scroll */
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => arm()); else arm();
  document.addEventListener('shopify:section:load', e => arm(e.target));
})();
